import React, { useState } from "react";

import style from "../../sass/custom/inputs.module.scss";
import { Button } from "@mui/material";
import { validators } from "../../validators/validators";
import { setPathToHome, setPathToShipments } from "../path/pathSlice";
import { useDispatch } from "react-redux";
import { createShipmentFromCalculator } from "../shipments/shipmentsSlice";

const validate = (fullName, phone, email) => {
    const errors = {}
    let err = null
    
    err = validators.ValidateLength(fullName, 3)
    if (err !== null)
        errors.fullName = err
    if (!fullName || validators.ValidateLength(fullName, 3)) {
        errors.fullName = "Введите ФИО"

    }

    err = validators.ValidateLength(phone, 7)
    if(err !== null)
        errors.phone = err
    if (!phone) {
        errors.phone = "Введите телефон"
    }

    err = validators.ValidateEmail(email)
    if(err !== null)
        errors.email = err
    if (!email) {
        errors.email = "Введите email"
    }
    
    return errors
}

const ContactPage = () => {
    const dispatch = useDispatch()

    const [fullName, setFullName] = useState("")
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")


    const [errors, setErrors] = useState({})

    const validateInputs = () => {
        const errors = validate(fullName, phone, email)
        setErrors(errors)
        return Object.keys(errors).length === 0
    }

    const handleLeaveRequestButtonClick = () => {
        let isValid = validateInputs()
        if (!isValid) return

        dispatch(setPathToHome())
    }
    const handleGoToCreateShipmentButtonClick = () => {
        dispatch(setPathToShipments())
    }

    return (
        <div>
            <div className="mb-6">
                <div className="grid grid-cols-12 items-center">
                    <span className="col-span-4 text-left text-3xs xs:text-sm sm:text-sm font-extralight">
                        ФИО
                    </span>
                    <input
                        type="text"
                        className="col-span-8 border-b border-b-gray-400 hover:border-b-gray-500 text-left p-2 focus:outline-none text-3xs xs:text-xs sm:text-sm font-light"
                        placeholder="Введите ФИО"
                        value={fullName}
                        onInput={e => {
                            setErrors(prev => ({
                                ...prev,
                                fullName: ""
                            }))
                            setFullName(e.target.value)
                        }}
                    />
                    {/* error */}
                    <span className="grid grid-cols-12 col-span-12">
                        <span className="col-span-4"></span>
                        <span className="col-span-8 text-left text-red-700 text-3xs xs:text-xs sm:text-sm font-light">{errors.fullName}</span>
                    </span>
                </div>
                <div className="grid grid-cols-12 items-center">
                    <span className="col-span-4 text-left text-3xs xs:text-sm sm:text-sm font-extralight">
                        Телефон
                    </span>
                    <input
                        type="text"
                        className="col-span-8 border-b border-b-gray-400 hover:border-b-gray-500 text-left p-2 focus:outline-none text-3xs xs:text-xs sm:text-sm font-light"
                        placeholder="телефон для связи"
                        value={phone}
                        onInput={e => {
                            setErrors(prev => ({
                                ...prev,
                                phone: ""
                            }))
                            setPhone(e.target.value)
                        }}
                    />
                    {/* error */}
                    <span className="grid grid-cols-12 col-span-12">
                        <span className="col-span-4"></span>
                        <span className="col-span-8 text-left text-red-700 text-3xs xs:text-xs sm:text-sm font-light">{errors.phone}</span>
                    </span>
                </div>
                <div className="grid grid-cols-12 items-center">
                    <span className="col-span-4 text-left text-3xs xs:text-sm sm:text-sm font-extralight">
                        Email
                    </span>
                    <input
                        type="text"
                        className="col-span-8 border-b border-b-gray-400 hover:border-b-gray-500 text-left p-2 focus:outline-none text-3xs xs:text-xs sm:text-sm font-light"
                        placeholder="e-mail"
                        value={email}
                        onInput={e => {
                            setErrors(prev => ({
                                ...prev,
                                email: ""
                            }))
                            setEmail(e.target.value)
                        }}
                    />
                    {/* error */}
                    <span className="grid grid-cols-12 col-span-12">
                        <span className="col-span-4"></span>
                        <span className="col-span-8 text-left text-red-700 text-3xs xs:text-xs sm:text-sm font-light">{errors.email}</span>
                    </span>
                </div>
            </div>

            <div className="">
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        padding: "0.5rem 1rem",
                        width: "90%",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={handleLeaveRequestButtonClick}
                >Оставить заявку</Button>
            </div>
        </div>
    );
};

export default ContactPage;
